var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.233887","y1":"10.1183","x2":"21.0481","y2":"10.1183","stroke":"#329952","key":0}),React.createElement("line",{"x1":"10.9072","y1":"0.0455322","x2":"10.9072","y2":"20.8597","stroke":"#329952","key":1})]);
}

PlusInline.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
